<template>
  <div class="step1">
    <div class="cart-list" ref="cartlist">
      <div class="product-check show-on-pad-flex">
        <div class="label-group">
          <input type="checkbox" id="all_check" @change="handleCheckAllProduct"><label class="square" for="all_check">{{ $t('cart_page.product') }}</label>
        </div>  
      </div>
      <div class="table-header hide-on-pad-flex">
        <div class="td detail">{{ $t('cart_page.info') }}</div>
        <div class="td price">{{ $t('cart_page.price') }}</div>
        <div class="td qty">{{ $t('cart_page.qty') }}</div>
        <div class="td count">{{ $t('cart_page.unit_count') }}</div>
        <div class="td operate"></div>
      </div>
      <div class="table-body" v-if="cars.length>0">
        <div class="tr hide-on-pad-flex" v-for="(item,index) in cars" :key="index+'_pc'">
          <div class="td detail">
            <div class="img-block">
              <img :src="item.photo" alt="product-img">
            </div>
            <div class="detail-content">
              <p>{{ $t('cart_page.name') }}: {{ item.name }}</p>
              <p>{{ item.color }}, {{ item.standard }}{{ item.size }}</p>
              <p class="p-no">{{ $t('cart_page.no') }}: {{ item.no }}</p>
            </div>
          </div>
          <div class="td price">{{ item.price | formatPrice}}</div>
          <div class="td qty">
            <el-input-number v-model="item.qty" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number>
          </div>
          <div class="td count">{{ item.price*item.qty | formatPrice}}</div>
          <div class="td operate">
            <Icon type="trash" @clickevent="handleRemove(index)"/>
          </div>
        </div>
        <div class="tr show-on-pad-flex" v-for="(item,index) in cars" :key="index+'_mob'">
          <div class="label-group">
            <input type="checkbox" :id="index+'_mob_checkbox'" v-model="item.checked"><label class="square" :for="index+'_mob_checkbox'"></label>
          </div>  
          <div class="td img"><img :src="item.photo" alt="product-img"></div>
          <div class="td detail">
            <div>
              <p class="p-no">{{ $t('cart_page.no') }}: {{ item.no }}</p>
              <p class="name">{{ item.name }}</p>
            </div>
            <div>
              <span class="color">{{ $t('cart_page.color') }}: {{ item.color }}</span>
              <span class="size" v-show="!item.adjust">{{ $t('cart_page.size') }}: {{ item.standard }}{{ item.size }}</span>
              <span class="qty"><span v-show="!item.adjust">x {{ item.qty }}</span> <el-input-number v-show="item.adjust" v-model="item.qty" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number></span>
            </div>
            <p class="price">{{ item.price*item.qty | formatPrice}}</p>
          </div>
          <div class="operate">
            <div class="btn" @click="handleAdjustQty(index)">{{ item.adjust ? $t('cart_page.close') : $t('cart_page.edit') }}</div>
            <div class="btn" @click="handleRemove(index)">{{ $t('cart_page.delete') }}</div>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>
        {{ $t('cart_page.empty') }}
      </div>
    </div>

    <div class="card-list hide-on-pad-flex">
      <div class="card coupon">
        <div class="card-title">{{ $t('cart_page.has_coupon') }}</div>
        <div class="card-body">
          <div class="group-item">
            <input type="text" @change="handleCouponInputChange" :value="useCouponTemp" :placeholder="$t('cart_page.coupon_placeholder')">
            <div class="btn btn-orange" @click="handleEnterCoupon">{{ $t('cart_page.enter') }}</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-title">{{ $t('cart_page.price_title') }}</div>
        <div class="card-body">
          <p class="cart-info">{{ $t('cart_page.count') }}<span>{{ totalCount | formatPrice }}</span></p>
          <p class="cart-info">{{ $t('cart_page.ship_fee') }}<span>{{ shipPrice | formatPrice }}</span></p>
          <p class="cart-info coupon">
            {{ $t('cart_page.coupon') }}
            <span>
              <span class="cancel" @click="cancelCoupon" v-show="couponPrice!='0'">X</span>
                {{ couponPrice }}
              </span>
            </p>
          <p class="cart-info">{{ $t('cart_page.total') }}<span>{{  totalPrice | formatPrice }}</span></p>
        </div>
        <div class="card-foot">
          <div class="btns">
            <div class="btn btn-grey" @click="handleContinu">{{ $t('cart_page.continue') }}</div>
            <div class="btn btn-orange" @click="handleCheckout">{{ $t('cart_page.checkout') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="border-bottom: 1px solid #E6E6E6;margin-bottom: 40px">
      <div class="card show-on-pad">
        <div class="card-title">{{ $t('cart_page.price_title') }}</div>
        <div class="card-body">
          <div class="btn btn-orange show-coupon-btn" @click="handleShowCouponBlock">{{ mobileShowCouponBlock ? $t('cart_page.close') : $t('cart_page.use_coupon') }}</div>
          <div class="use-coupon-block" :class="{ active: mobileShowCouponBlock }">
            <input type="text" @change="handleCouponInputChange" :value="useCouponTemp">
            <div class="btn btn-orange" @click="handleEnterCoupon">{{ $t('cart_page.enter') }}</div>
          </div>
          <p class="cart-info">{{ $t('cart_page.count') }}<span>{{ totalCount | formatPrice }}</span></p>
          <p class="cart-info">{{ $t('cart_page.ship_fee') }}<span>{{ shipPrice | formatPrice }}</span></p>
          <p class="cart-info coupon">
            {{ $t('cart_page.coupon') }}
            <span>
              <span class="cancel" @click="cancelCoupon">X</span>
                {{ couponPrice }}
              </span>
            </p>
          <p class="cart-info total">{{ $t('cart_page.total') }}<span>{{ totalPrice | formatPrice }}</span></p>
        </div>
        <div class="card-foot">
          <div class="btns mobile-btns">
            <!-- <div class="btn btn-grey" @click="handleContinu">继续购物</div> -->
            <div class="price">
              <p class="cart-info total">{{ $t('cart_page.total') }}<span>{{ totalPrice | formatPrice }}</span></p>
              <p class="cart-info coupon">
                {{ $t('cart_page.coupon') }}
                <span>
                  {{ couponPrice }}
                </span>
              </p>
            </div>
            <div class="btn btn-orange" @click="handleCheckout">{{ $t('cart_page.checkout') }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <GoodsFlexible :list="recommendList" :title="$t('goodsFlexible.recommend')" sub-title="RECOMMEND" tag="hot" />
    <GoodsFlexible :list="recentGoods"  :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="hot" />
  </div>
</template>

<script>
import { getGoodsList } from '@/api/index.js'
import GoodsFlexible from "@/components/GoodsFlexible";
import Mixin from "@/utils/goodsMixin";
import { Loading } from 'element-ui';
import { cloudConfirm } from '@/utils/tools.js'
import { removeProduct } from '@/api'

  export default {
    name: 'CartStep1',
    components: {
      GoodsFlexible
    },
    mixins: [Mixin],
    props: {
      cars: {
        type: Array,
        default: () => []
      },
      useCouponTemp: {
        type: String,
        default: ''
      },
      totalCount: {
        type: Number,
        default: 0
      },
      shipPrice: {
        type: Number,
        default: 0
      },
      couponPrice: {
        type: String,
        default: 0
      },
      totalPrice: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        recommendList: '',
        pageSize: 20,
        mobileShowCouponBlock: false, // 是否呈现输入优惠券的区块
      }
    },
    filters: {
      formatPrice(value) {
        let priceText = 0;
        if(value && value!='undefined') priceText = value;
        const priceArr = String(priceText).split('');
        let price = '';
        priceArr.forEach((item, index) => {
            if (index >= 3 && index % 3 == 0) {
                price = priceArr[priceArr.length - index - 1] + ',' + price;
            } else {
                price = priceArr[priceArr.length - index - 1] + price;
            }
        })
        return '$'+price;
      },
      formatEmpty(value) {
        if(!value) return this.$t('format.empty');
        return value;
      }
    },
    computed: {
      // getTotalCount() {
      //   // 计算一下购物车里面的价格
      //   return this.doTotalCount();
      // },
      // getShipPrice() {
      //   // 需判断价格是否超过免运的价格，如果没有就加入运费
      //   return this.doShipPrice();
      // },
      // getCouponPrice() {
      //   return this.doCouponPrice();
      // },
      // getTotalPrice() {
      //   return this.doTotalCount() + this.doShipPrice() + this.doCouponPrice();
      // }
    },
    created() {
      
    },
    mounted() {
      this.$nextTick(() => {
        this.getRecommendList();
      });
    },
    methods: {
      async getRecommendList(data) {
        getGoodsList({ recommend: this.pageSize }).then((res) => {
          this.recommendList = res.recommend;
        });
      },
      handleChange(val) {
        console.log('qty change to ',val);
      },
      handleCheckAllProduct(e) {
        const checked = e.target.checked;
        const newCars = this.cars.map(item => { return { ...item, checked }});
        
        this.$emit('cartChange',newCars);
      },
      handleContinu() {
        this.$router.push({name:'goods'});
      },
      handleCheckout() {
        // todo
        // 如果购物车没有商品的话就不能跳下一步
        if(this.cars.length<=0) {
          this.$message(this.$t('alert_message.cant_checkout_for_empty'));
          return;
        }
        
        this.$emit('next', 'ship');
      },
      handleAdjustQty(index) {
        this.cars[index].adjust = !this.cars[index].adjust;
        // this.$emit('cartChange',newCars);
      },
      async handleRemove(index) {
        try {
          await cloudConfirm();
          const { id:cartsId, qty } = this.cars[index];
          await removeProduct({ cartsId, qty });
          this.$store.commit('MINUS_CART_NUMBER');
          this.$message({
            message: this.$t('alert_message.remove_success'),
            type: 'success'
          });
          // 从购物车中把被删除的移掉
          this.cars.splice(index,1);
        } catch (error) {
          // 取消删除
          console.log(error);
        }
      },
      handleEnterCoupon() {
        if(this.useCouponTemp=='') return;
        this.$emit('changeCoupon');
      },
      handleCouponInputChange(e) {
        console.log('val',e.target.value);
        this.$emit('update:useCouponTemp', e.target.value);
      },
      cancelCoupon() {
        console.log('cancelCoupon');
        // 清空优惠卷
        this.$emit('update:useCouponTemp', '');
        // 重新计算
        this.$emit('changeCoupon');
      },
      handleShowCouponBlock() {
        this.mobileShowCouponBlock = !this.mobileShowCouponBlock;
      }
    }
  }
</script>

<style lang="less" scoped>
.step1 {
  .cart-list {
    width: 100%;
    // text-align: center;
    margin-bottom: 30px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    @media (max-width: 992px) {
      border: unset;
    }
    .product-check {
      padding: 10px 0;
      padding-left: 16px;
      background: #F7F8FA;
      margin-left: -16px;
      margin-right: -16px;
    }
    .table-header {
      // background: #F0F0F0;
      padding: 15px 15px;
      display: flex;
      margin-bottom: 10px;
      border-bottom: 1px solid #F0F0F0;
    }
    .table-body {
      .tr {
        display: flex;
        border-bottom: 1px solid #E6E6E6;
        padding: 20px 0;
        &:nth-last-child(2) {
          border-bottom: unset;
        }
        &.show-on-pad-flex {
          padding-left: 30px;
          position: relative;
          .label-group {
            position: absolute;
            left: 0px;
          }
        }
      }
      .detail {
        text-align: left;
      }
    }
    // .index {
    //   flex: 0 0 13%;
    // }
    // .img {
    //   flex: 0 0 20%;
    //   margin: 0 15px;
    //   position: relative;
    //   padding-top: calc(20%/240*300);
    //   &.withoutPT {
    //     padding-top: 0;
    //   }
    //   img {
    //     width: 100%;
    //     height: 100%;
    //     object-fit: cover;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     display: block;
    //   }
    // }
    // .detail {
    //   flex: 0 0 30%;
    //   position: relative;
    //   p {
    //     margin-bottom: 10px;
    //   }
    //   .p-no {
    //     position: absolute;
    //     bottom: 0;
    //     left: 0;
    //   }
    // }
    // .qty {
    //   flex: 0 0 18%;
    // }
    // .price {
    //   flex: 0 0 19%;
    // }
    .img {
      width: 100px;
      height: 100px;
      overflow: hidden;
      border-radius: 8px;
      margin-right: 10px;
      img {
        width: 100%;
      }
    }
    .detail {
      flex: 0 0 40%;
      display: flex;
      @media (max-width: 992px) {
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        .name {
          font-size: 1.1rem;
          font-weight: 400;
        }
        .p-no {
          font-size: 0.8rem;
          margin-bottom: 5px;
          font-weight: 300;
        }
        .color {
          font-size: 0.8rem;
          margin-right: 18px;
        }
        .size {
          font-size: 0.8rem;
          margin-right: 18px;
        }
        .qty {
          font-size: 0.8rem;
          /deep/ .el-input-number {
            line-height: 26px;
            margin-top: 5px;
            margin-bottom: 16px;
            .el-input__inner {
              height: 30px;
            }
          }
        }
        .price {
          color: #EC4F00;
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
      .img-block {
        width: 120px;
        height: 150px;
        margin-right: 20px;
        position: relative;
        overflow: hidden;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }
      }
      .detail-content {
        flex: 1;
        height: 100%;
        position: relative;
        padding-right: 20px;
        p {
          margin-bottom: 10px;
        }
        .p-no {
          position: absolute;
          bottom: 0;
          left: 0;
          font-size: 0.8rem;
        }
      }
    }
    .price {
      flex: 0 0 20%;
    }
    .qty {
      flex: 0 0 15%;
      /deep/ .el-input-number {
        width: 80px;
        .el-input-number__decrease,.el-input-number__increase {
          width: 20px;
          border: 1px solid #F0F0F0;
          background: #F0F0F0;
          border-radius: 0;
        }
        .el-input__inner {
          padding: 0;
          border: 1px solid #F0F0F0;
          border-radius: 0;
        }
      }
    }
    .count {
      flex: 0 0 15%;
    }
    .operate {
      flex: 0 0 10%;
      /deep/ .cloud-icon {
        margin-right: 0;
        margin-left: auto;
        svg {
          fill: #656565;
        }
      }
      
      @media (max-width: 992px) {
        display: flex;
        position: absolute;
        bottom: 20px;
        right: 0;
        flex-direction: row;
        .btn {
          cursor: pointer;
          box-shadow: unset;
          color: #707070;
          border: 1px solid #707070;
          padding: 4px 8px;
          width: 100%;
          margin-left: 10px;
          &:nth-child(1) {
            margin-left: 0;
          }
        }
      }
    }
  }

  .card-list {
    display: flex;
    margin-bottom: 100px;
  }
  .card {
    &.coupon {
      align-self: baseline;
      .group-item {
        display: flex;
        width: 100%;
        padding: 40px;
        background: #FAFAFA;
        .btn {
          width: 120px;
        }
        input {
          flex: 1;
          margin-right: 20px;
          border: 1px solid #E6E6E6;
        }
      }
    }
    &.show-on-pad {
      margin-left: 20px !important;
      margin-right: 20px;
      padding-bottom: 0;
      .card-foot {
        background: white;
        border-top: 0;
        margin-left: -15px;
        margin-right: -15px;
      }
    }
    
  }

  .show-coupon-btn {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .use-coupon-block {
    flex: 0 0 100%;
    margin-bottom: 20px;
    display: none;
    .btn {
      padding: 0 20px;
      display: flex;
      align-items: center;
    }
    &.active {
      display: flex;
    }
  }
  .mobile-btns {
    padding: 0 !important;
    justify-content: space-between !important;
    .price {
      color: #EC4F00;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .btn-orange {
        flex: 0 0 125px !important;
      }
      p {
        font-weight: 400;
      }
      p:nth-child(1) {
        font-size: 0.8rem;
      }
      p:nth-child(2) {
        font-size: 0.8rem;
        transform: scale(.8);
        transform-origin: 0% 100%;
        // margin-bottom: 10px;
      }
    }
  }
}
</style>